/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-union-intersect-except-visualizer block)");
/* eslint-enable no-console */

(function () {
    var dataA = [
        { id: 1, nom: "Alice", ville: "Paris" },
        { id: 2, nom: "Bob", ville: "Lyon" },
        { id: 3, nom: "Claire", ville: "Bordeaux" },
        { id: 4, nom: "David", ville: "Paris" }
    ];

    var dataB = [
        { id: 3, nom: "Claire", ville: "Bordeaux" },
        { id: 4, nom: "David", ville: "Paris" },
        { id: 5, nom: "Emma", ville: "Bruxelles" },
        { id: 6, nom: "Frank", ville: "Li\u00e8ge" }
    ];

    function rowKey(r) { return r.id + "|" + r.nom + "|" + r.ville; }

    var keysA = {};
    dataA.forEach(function (r) { keysA[rowKey(r)] = true; });
    var keysB = {};
    dataB.forEach(function (r) { keysB[rowKey(r)] = true; });

    var ops = {
        "UNION": {
            compute: function () {
                var seen = {};
                return dataA.concat(dataB).filter(function (r) {
                    var k = rowKey(r);
                    if (seen[k]) return false;
                    seen[k] = true; return true;
                });
            },
            sql: "SELECT id, nom, ville FROM clients_france\nUNION\nSELECT id, nom, ville FROM clients_belgique;",
            explication: "<strong>UNION</strong> combine les lignes des deux tables et <strong>supprime les doublons</strong>. Les lignes identiques (m\u00eame id, nom, ville) n\u2019apparaissent qu\u2019une seule fois dans le r\u00e9sultat.",
            classA: function () { return "row-included"; },
            classB: function () { return "row-included"; },
            venn: "all"
        },
        "UNION ALL": {
            compute: function () { return dataA.concat(dataB); },
            sql: "SELECT id, nom, ville FROM clients_france\nUNION ALL\nSELECT id, nom, ville FROM clients_belgique;",
            explication: "<strong>UNION ALL</strong> combine toutes les lignes des deux tables <strong>sans supprimer les doublons</strong>. Les lignes communes apparaissent deux fois. Plus rapide que UNION car pas de d\u00e9duplication.",
            classA: function () { return "row-included"; },
            classB: function () { return "row-included"; },
            venn: "all"
        },
        "INTERSECT": {
            compute: function () {
                return dataA.filter(function (r) { return keysB[rowKey(r)]; });
            },
            sql: "SELECT id, nom, ville FROM clients_france\nINTERSECT\nSELECT id, nom, ville FROM clients_belgique;",
            explication: "<strong>INTERSECT</strong> retourne uniquement les lignes <strong>pr\u00e9sentes dans les deux tables</strong>. Seuls les enregistrements communs (m\u00eame id, nom, ville) sont conserv\u00e9s.",
            classA: function (r) { return keysB[rowKey(r)] ? "row-included" : "row-excluded"; },
            classB: function (r) { return keysA[rowKey(r)] ? "row-included" : "row-excluded"; },
            venn: "intersect"
        },
        "EXCEPT": {
            compute: function () {
                return dataA.filter(function (r) { return !keysB[rowKey(r)]; });
            },
            sql: "SELECT id, nom, ville FROM clients_france\nEXCEPT\nSELECT id, nom, ville FROM clients_belgique;",
            explication: "<strong>EXCEPT</strong> retourne les lignes de la <strong>premi\u00e8re table qui ne sont pas dans la seconde</strong>. C\u2019est la diff\u00e9rence ensembliste A \u2212 B. L\u2019ordre est important\u00a0: A EXCEPT B \u2260 B EXCEPT A.",
            classA: function (r) { return keysB[rowKey(r)] ? "row-excluded" : "row-included"; },
            classB: function () { return "row-excluded"; },
            venn: "except"
        }
    };

    function updateVenn(type) {
        var zA = document.getElementById("zoneA");
        var zB = document.getElementById("zoneB");
        var zI = document.getElementById("zoneIntersect");
        var zEM = document.getElementById("zoneExceptMask");
        var color = "#6366f1";

        zA.setAttribute("fill-opacity", "0");
        zB.setAttribute("fill-opacity", "0");
        zI.setAttribute("fill-opacity", "0");
        zEM.setAttribute("fill-opacity", "0");

        if (type === "all") {
            zA.setAttribute("fill", color); zA.setAttribute("fill-opacity", "0.25");
            zB.setAttribute("fill", color); zB.setAttribute("fill-opacity", "0.25");
            zI.setAttribute("fill", color); zI.setAttribute("fill-opacity", "0.25");
        } else if (type === "intersect") {
            zI.setAttribute("fill", color); zI.setAttribute("fill-opacity", "0.45");
        } else if (type === "except") {
            zA.setAttribute("fill", color); zA.setAttribute("fill-opacity", "0.35");
            zEM.setAttribute("fill", "#ffffff"); zEM.setAttribute("fill-opacity", "1");
        }
    }

    function renderTable(tableId, data, classFn) {
        var tbody = document.querySelector("#" + tableId + " tbody");
        tbody.innerHTML = "";
        data.forEach(function (r) {
            var tr = document.createElement("tr");
            tr.className = classFn ? classFn(r) : "";
            tr.innerHTML = "<td>" + r.id + "</td><td>" + r.nom + "</td><td>" + r.ville + "</td>";
            tbody.appendChild(tr);
        });
    }

    function renderResult(data) {
        var tbody = document.querySelector("#tableResult tbody");
        tbody.innerHTML = "";
        data.forEach(function (r) {
            var tr = document.createElement("tr");
            tr.innerHTML = "<td>" + r.id + "</td><td>" + r.nom + "</td><td>" + r.ville + "</td>";
            tbody.appendChild(tr);
        });
    }

    function update(op) {
        var cfg = ops[op];
        document.getElementById("opLabel").textContent = op;
        document.getElementById("sqlCode").textContent = cfg.sql.replace(/\\n/g, "\n");
        document.getElementById("explication").innerHTML = cfg.explication;
        renderTable("tableA", dataA, cfg.classA);
        renderTable("tableB", dataB, cfg.classB);
        renderResult(cfg.compute());
        updateVenn(cfg.venn);
        document.querySelectorAll(".op-btn").forEach(function (b) {
            b.classList.toggle("active", b.getAttribute("data-op") === op);
        });
    }

    document.querySelectorAll(".op-btn").forEach(function (btn) {
        btn.addEventListener("click", function () { update(btn.getAttribute("data-op")); });
    });

    update("UNION");
})();